import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { get } from '@cullylarson/f';
import { preventDefault } from '@@client/lib/events';
import FormEmail from '@@client/components/FormEmail';
import FormPassword from '@@client/components/FormPassword';
import FormCheckbox from '@@client/components/FormCheckbox';
export default function LoginForm(props) {
  var _useState = useState(get('email', '', props)),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = useState(get('password', '', props)),
      password = _useState2[0],
      setPassword = _useState2[1];

  var _useState3 = useState(get('rememberMe', true, props)),
      rememberMe = _useState3[0],
      setRememberMe = _useState3[1];

  var disabled = get('disabled', false, props);
  var buttonTitle = get('buttonTitle', 'Login', props);
  var idPrefix = get('idPrefix', 'login', props);
  var paramErrors = get('paramErrors', {}, props);
  var onSubmit = get('onSubmit', function () {}, props);

  var handleParam = function handleParam(setValue) {
    return function (e) {
      return e && e.target ? setValue(e.target.value) : setValue(e);
    };
  };

  var handleParamCheckbox = function handleParamCheckbox(setValue) {
    return function (e) {
      return e && e.target && e.target.checked ? setValue(true) : setValue(false);
    };
  };

  var handleSubmit = preventDefault(function () {
    onSubmit({
      email: email,
      password: password,
      rememberMe: rememberMe
    });
  });
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit,
    children: [/*#__PURE__*/_jsx("p", {
      className: "description",
      children: "If you created an account on the old Autowrecking.com site, your account is still here. You just need to reset your password. You can do that by clicking the 'Forgot your password?' link below."
    }), /*#__PURE__*/_jsx(FormEmail, {
      idPrefix: idPrefix,
      name: "email",
      title: "Email",
      value: email,
      onChange: handleParam(setEmail),
      errors: get('email', [], paramErrors),
      autoComplete: "email"
    }), /*#__PURE__*/_jsx(FormPassword, {
      idPrefix: idPrefix,
      name: "password",
      title: "Password",
      value: password,
      onChange: handleParam(setPassword),
      errors: get('password', [], paramErrors),
      autoComplete: "current-password"
    }), /*#__PURE__*/_jsx(FormCheckbox, {
      idPrefix: idPrefix,
      name: "rememberMe",
      title: "Remember me",
      isChecked: rememberMe,
      onChange: handleParamCheckbox(setRememberMe)
    }), /*#__PURE__*/_jsx("div", {
      className: "actions",
      children: /*#__PURE__*/_jsx("button", {
        className: "btn btn--yellow",
        type: "submit",
        disabled: disabled,
        children: buttonTitle
      })
    })]
  });
}